'use client'
import { useLang } from '../../context/LangContext'
import { t, productMonitoring } from '../../lib/translations'
import ProductLanding from '../../components/ProductLanding'
import Icon from '../../components/Icon'

const featureIcons = ['chart-bar', 'container', 'lightning', 'collection', 'bell', 'apps', 'check-circle', 'users'] as const

export default function MonitoringPage() {
  const lang = useLang()
  const features = productMonitoring.features.map((f, i) => ({
    title: t(lang, f.title),
    description: t(lang, f.description),
    icon: <Icon name={featureIcons[i]} className="w-6 h-6" strokeWidth={1.5} />,
  }))
  const benefits = productMonitoring.benefits.map((b) => ({ title: t(lang, b.title), desc: t(lang, b.desc) }))

  return (
    <ProductLanding
      id="monitoring"
      title={t(lang, productMonitoring.title)}
      subtitle={t(lang, productMonitoring.subtitle)}
      description={t(lang, productMonitoring.description)}
      heroBg="bg-gradient-to-b from-[#818cf8]/5 via-transparent to-transparent"
      heroGlow="bg-[#a5b4fc]/10"
      features={features}
      benefits={benefits}
    />
  )
}
